import { UserManager, WebStorageStateStore } from "oidc-client-ts";
import { config } from "../config";

// Потребителят (токените) е в localStorage, така че е общ за всички раздели и
// нов раздел не минава през keycloak. Сесията се ограничава от keycloak:
// refresh токенът важи, докато е жива сесията там (без offline_access, иначе
// keycloak издава offline токен, който не зависи от сесията).
export const userManager = new UserManager({
  authority: config.authServer,
  client_id: config.authClientId,
  client_secret: config.authClientSecret,
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  scope: "openid profile email",
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
});

// Токенът за достъп е изтекъл - или подновяването преди това не е успяло, или
// страницата е отворена със запазен, вече изтекъл токен (напр. на другия ден).
// Опит с refresh токена; ако сесията в keycloak е изтекла, потребителят се
// премахва и WithAuth/WithAnyRole пренасочват към вход.
userManager.events.addAccessTokenExpired(async () => {
  try {
    await userManager.signinSilent();
  } catch (error) {
    console.warn("Session expired:", error);
    await userManager.removeUser();
  }
});

// Изход в друг раздел - премахнат е потребителят от localStorage (key е null,
// когато е изчистен целият localStorage)
window.addEventListener("storage", (event) => {
  if (
    event.key === null ||
    (event.key.startsWith("oidc.user:") && event.newValue === null)
  ) {
    void userManager.removeUser();
  }
});
